import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, change} from 'redux-form';
import {SelectAsync} from 'components/common/fields';

class AutoSuggestSelect extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    validate: PropTypes.array,
    initialValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    labelKey: PropTypes.string,
    valueKey: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
    multi: PropTypes.bool,
    creatable: PropTypes.bool,
    filterOptions: PropTypes.bool,
    noResultsText: PropTypes.bool,
  };

  static defaultProps = {
    initialValue: null,
    labelKey: 'label',
    valueKey: 'value',
    required: false,
    creatable: false,
    multi: false,
    openOnFocus: true,
    searchPromptText: false,
    loadingPlaceholder: false,
    noResultsText: false,
    removeSelected: true,
    matchPos: 'any',
  };

  constructor(props) {
    super(props);
    this.initialize();
  }

  initialize = () => {
    const {defaultValue, formName, name, change} = this.props;
    if (defaultValue) {
      change(formName, name, defaultValue);
    }
  };

  fetchOptions = (value) => this.props.onSearch(value).then((options) => ({options}));

  render() {
    const {name, label, required, validate, initialValue, multi, ...restProps} = this.props;
    return (
      <Field
        {...{
          ...restProps,
          name,
          label,
          component: SelectAsync,
          required,
          validate,
          initialValue,
          multi,
          autoBlur: !multi,
          closeOnSelect: !multi,
          loadOptions: this.fetchOptions,
        }}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  change: (formName, fieldName, value) => dispatch(change(formName, fieldName, value)),
});

export default connect(null, mapDispatchToProps)(AutoSuggestSelect);
